import React from 'react';

import { Label } from 'shadcn/components/ui/Label';
import { Textarea } from 'shadcn/components/ui/Textarea';

export const VENDOR_PDF_NOTE_MAX_LENGTH = 200;
export const VENDOR_PDF_NOTE_PLACEHOLDER = 'Add a custom note here for the vendor if you would like';

/**
 * Custom note to vendor for the PO PDF. Editable only when the page is in Edit mode.
 *
 * @param {Object} props
 * @param {boolean} [props.isEditing=false]
 * @param {boolean} [props.isSaving=false]
 * @param {(value: string) => void} [props.onChange]
 * @param {string} [props.value='']
 */
export function PurchaseOrderVendorPdfNoteCard({ isEditing = false, isSaving = false, onChange, value = '' }) {
    const displayValue = value ?? '';
    const characterCount = displayValue.length;

    const handleChange = (event) => {
        if (typeof onChange !== 'function') return;
        const nextValue = String(event.target.value ?? '').slice(0, VENDOR_PDF_NOTE_MAX_LENGTH);
        onChange(nextValue);
    };

    return (
        <div className="rounded-md border bg-card p-4 shadow-sm">
            <div className="flex flex-col gap-3">
                <div className="flex flex-col gap-1">
                    <h2 className="text-left text-base font-semibold tracking-tight text-foreground">
                        Custom Note To Vendor
                    </h2>
                    <p className="text-left text-xs text-muted-foreground">
                        Included on the vendor PDF. Maximum {VENDOR_PDF_NOTE_MAX_LENGTH} characters.
                    </p>
                </div>

                <div className="flex flex-col gap-2">
                    <Label htmlFor="vendor-pdf-note" className="sr-only">
                        Custom Note To Vendor
                    </Label>
                    <Textarea
                        id="vendor-pdf-note"
                        name="vendorPdfNote"
                        aria-label="Custom Note To Vendor"
                        value={displayValue}
                        onChange={handleChange}
                        placeholder={VENDOR_PDF_NOTE_PLACEHOLDER}
                        maxLength={VENDOR_PDF_NOTE_MAX_LENGTH}
                        disabled={!isEditing || isSaving}
                        rows={5}
                        className="min-h-[120px] max-h-[220px] resize-y overflow-y-auto"
                    />
                    <div className="flex justify-end">
                        <span className="text-xs text-muted-foreground">
                            {characterCount} / {VENDOR_PDF_NOTE_MAX_LENGTH}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

PurchaseOrderVendorPdfNoteCard.displayName = 'PurchaseOrderVendorPdfNoteCard';
